import React from 'react';
import moment from 'moment';

const ConfirmDriveRegistration = ({ drive, onConfirm, onClose }) => {
    return (
        <div>

            {/* Title */}
            <h5 className="mb-2">
                {drive.DRIVE_NAME}
                {drive.DRIVE_CODE && (
                    <span className="text-muted ms-2">
                        ({drive.DRIVE_CODE})
                    </span>
                )}
            </h5>

            {/* College */}
            <p className="mb-1">
                🏫 <strong>{drive.COLLEGE_NAME}</strong>
            </p>

            <p className="mb-1">
                📍 {drive.COLLEGE_CITY}, {drive.COLLEGE_STATE}
            </p>

            {/* Schedule */}
            <p className="mb-2">
                📅 {moment(drive.DRIVE_DATE).format('DD MMM YYYY')}
                &nbsp;⏰ {drive.DRIVE_START_TIME} – {drive.DRIVE_END_TIME}
            </p>

            {/* Capacity */}
            <p className="mb-1">
                👔 Max Employers: <strong>{drive.MAX_EMPLOYERS || 'N/A'}</strong>
            </p>

            <p className="mb-1">
                🎓 Max Students: <strong>{drive.MAX_STUDENTS || 'N/A'}</strong>
            </p>

            {/* Registration Deadline */}
            {drive.REGISTRATION_DEADLINE && (
                <p className="mb-2 text-danger">
                    ⏳ Registration Deadline:&nbsp;
                    {moment(drive.REGISTRATION_DEADLINE).format('DD MMM YYYY, hh:mm A')}
                </p>
            )}

            {/* Description */}
            <p className="text-muted">
                {drive.DRIVE_DESCRIPTION ||
                    'You will be participating in this campus hiring drive.'}
            </p>

            <hr />

            {/* Actions */}
            <div className="d-flex justify-content-end">
                <button
                    className="btn btn-outline-secondary me-2"
                    onClick={onClose}
                >
                    Cancel
                </button>

                <button
                    className="btn btn-success"
                    onClick={onConfirm}
                >
                    Confirm Registration
                </button>
            </div>

        </div>
    );
};

export default ConfirmDriveRegistration;
